import { Button } from '@/components/ui/button';
import {MouseEventHandler} from "react";

export interface IButtonTableHeader {
    type: 'button'
    onClick: MouseEventHandler<HTMLButtonElement>
    label: string
    icon?: React.ReactNode
}
type Props = Omit<IButtonTableHeader, 'type'>
export function ButtonTableHeader({onClick, label, icon}: Props) {
  return (
      <Button
          variant="outline"
          size="sm"
          className="h-8 w-full gap-1"
          onClick={onClick}
      >
          {icon}
          <span>{label}</span>
      </Button>
  )
}